// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3cFbt","header":"MessagesList_header__6eY9y","chat":"MessagesList_chat__Ueu3v"};